module.exports = __webpack_public_path__ + "static/media/28.206e0ab8.jpg";